import { render } from "./SelectComponentFerramentaAssosiacao.vue?vue&type=template&id=7aad8e3c&scoped=true"
import script from "./SelectComponentFerramentaAssosiacao.vue?vue&type=script&lang=js"
export * from "./SelectComponentFerramentaAssosiacao.vue?vue&type=script&lang=js"

import "./SelectComponentFerramentaAssosiacao.vue?vue&type=style&index=0&id=7aad8e3c&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aad8e3c"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QBtn,QTable,QTr,QTh,QTd,QCheckbox,QPagination});
